import { render, staticRenderFns } from "./IconEuroShield.vue?vue&type=template&id=6df684e0"
import script from "./IconEuroShield.vue?vue&type=script&lang=js"
export * from "./IconEuroShield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports